goog.provide("shadow.js.shim.module$react_use$lib$useDebounce$default");
shadow.js.shim.module$react_use$lib$useDebounce$default = shadow.js.shim.module$react_use$lib$useDebounce.default;
